import { IDeviceInputDto } from './create-vehicle-input.interface';
import { ISemitrailerCapacity, ISemitrailerCompartment, ISemitrailerDimensions } from './semi-output-dto.interface';

export interface ICreateSemiInputDto {
    organizationId?: string;
    licensePlate: string;
    name: string;
    externalId?: string;
    vin?: string;
    make?: string;
    model?: string;
    year?: number;
    bodyType: string;
    cargoType?: string;
    axles?: string;
    dimensions?: ISemitrailerDimensions;
    capacity?: ISemitrailerCapacity;
    compartments?: ISemitrailerCompartment[];
    brakeType?: string[];
    suspensionType?: string;
    tireType?: string;
    kingPin?: string;
    carrierId?: string;
    vehicleId?: string;
    device?: IDeviceInputDto;
}
